export class Form {
    constructor(value) {
        this.value = value;
        this.valid = true;
        this.errors = {};
        this.submitted = false;
    }
}
;
